<div class="container-fluid reset-container">
  <div class="row reset-wrapper">
    <div class="col-lg-7 d-none d-lg-block image-container">
      <img
        src="https://kontact-app-public.s3-ap-southeast-1.amazonaws.com/images/Reset-Password.png"
        alt="Reset Password"
      />
    </div>

    <div class="col-lg-5 col-12 d-flex align-items-center justify-content-center reset-form-container">
      <div class="reset-box glass-effect">
        <h3 class="reset-heading">Reset Password</h3>

        <div class="portal-message" *ngIf="portalMessage; else normalMessage">
          {{ portalMessage }}
        </div>

        <ng-template #normalMessage>
          <p class="reset-description">
            Don't worry, it happens to the best of us.
          </p>
        </ng-template>

        <form [formGroup]="forgotPasswordForm" (ngSubmit)="sendOTP()">
          <div class="form-group">
            <input
              type="email"
              formControlName="email"
              class="form-control"
              placeholder="Email*"
              autocomplete="email"
            />
          </div>

          <div class="text-center mt-3">
            <button
              type="submit"
              class="btn btn-lite-blue"
              [disabled]="forgotPasswordForm.invalid || loadingSend"
            >
              <ng-container *ngIf="!loadingSend; else sendingTpl">
                Email me an OTP
              </ng-container>

              <ng-template #sendingTpl>
                <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                Sending...
              </ng-template>
            </button>
          </div>
        </form>

        <div class="text-center back-link">
          <a (click)="backTosignIn()">Back to Sign In</a>
        </div>
      </div>
    </div>
  </div>
</div>